import { GetCittaQuery, GetRegioneQuery } from '../../_graphql/generated';

export type RegioneState = {
  loading: boolean;
  lista: GetRegioneQuery['unita_amministrativa_regione'];
  failure: any;
};

export const initialRegioneState: RegioneState = {
  loading: false,
  lista: [],
  failure: '',
};
